var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(-1550 -4100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(1550 4100)",
    fill: "none",
    stroke: "#44d62c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-twitter",
    "data-name": "Icon awesome-twitter",
    d: "M11.868,6.058c.008.117.008.235.008.353a7.661,7.661,0,0,1-7.713,7.713A7.661,7.661,0,0,1,0,12.907a5.608,5.608,0,0,0,.655.034A5.429,5.429,0,0,0,4.02,11.782,2.716,2.716,0,0,1,1.486,9.9,3.419,3.419,0,0,0,2,9.944a2.867,2.867,0,0,0,.713-.092A2.711,2.711,0,0,1,.537,7.191V7.158A2.73,2.73,0,0,0,1.763,7.5,2.715,2.715,0,0,1,.923,3.876a7.706,7.706,0,0,0,5.59,2.837,3.06,3.06,0,0,1-.067-.621,2.714,2.714,0,0,1,4.692-1.855,5.337,5.337,0,0,0,1.721-.655,2.7,2.7,0,0,1-1.192,1.494,5.435,5.435,0,0,0,1.561-.42,5.828,5.828,0,0,1-1.36,1.4Z",
    transform: "translate(1556.697 4104.562)",
    fill: "#44d62c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.78cc3e7e688dd092d406808730bea210.svg";
export { ForwardRef as ReactComponent };